import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Body from '../../components/Body'
import TopBar from '../../components/TopBar'

import BackgroundImage from '../../assets/motor/shutterstock_435325255.jpg'
import BKIimage from '../../assets/motor/bki-logo.png'
import TrueMoney from '../../assets/motor/logo-truemoney.png'
import Lost from '../../assets/images/lost.png'

import Modal from '@material-ui/core/Modal'
import ErrorKYC from '../../assets/motor/ic-mobile-error@3x.png'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import SubmitButton from '../../components/SubmitButton'
import _ from 'lodash'

import Checkbox from '@material-ui/core/Checkbox'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backgroundImageContainer: {
    width: '100%',
    boxShadow: '0 2px 15px 0 rgba(91, 91, 91, 0.15)',
    paddingBottom: '5px',
    marginBottom: '9px',
  },
  backgroundImage: {
    objectFit: 'cover',
    objectPosition: '60% 0',
    width: '100%',
  },
  cardContainer: {
    display: 'flex',
    marginLeft: '10px',
    marginRight: '10px',
    justifyContent: 'center',
  },
  card: {
    width: '100%',
    marginLeft: '3px',
    marginRight: '3px',
    backdropFilter: 'blur(5.6px)',
    borderRadius: '8px',
    boxShadow:
      '0 4px 6px 0 rgba(35, 57, 120, 0.14), 0 0 4px 0 rgba(35, 57, 120, 0.12)',
    backgroundColor: '#ffffff',
  },
  cardTop: {
    width: '100%',
    padding: '16px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',

  },
  cardBottom: {
    width: '100%',
    padding: '16px',
    marginLeft: '3px',
    marginRight: '3px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',

  },
  cardTitle: {
    ...fontDefault,
    fontWeight: 'bold',
    color: '#FFFFFF',
    fontSize: '16px',
    textAlign: 'center',
    display: 'block',
    marginBottom: '8px',
  },
  cardDetail: {
    ...fontDefault,
    color: '#FFFFFF',
    fontSize: '12px',
    textAlign: 'center',
    display: 'block',
    marginBottom: '10px',
  },
  cardButton: {
    borderRadius: '14px',
    border: 'solid 1px #ff8300',
    backgroundColor: '#ffffff',
    fontWeight: 'bold',
    color: '#ff8300',
    fontSize: '12px',
    padding: '4px 20px',
  },
  cardButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoTruemoney: {
    height: '25px',
  },
  logoBKI: {
    marginLeft: '7px',
    height: '25px',
  },
  moreNewDesc: {
    color: '#878b96',
    ...fontDefault,
    //fontWeight: 'bold',
    fontSize: '14px',
    display: 'block',
    marginRight: '16px',
    marginLeft: '16px',
  },
  moreDesc: {
    color: '#878b96',
    textAlign: 'center',
    ...fontDefault,
    //fontWeight: 'bold',
    fontSize: '12px',
    display: 'block',
    marginRight: '16px',
    marginLeft: '16px',
  },
  modalContainer: {
    outline: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    width: '90%',
    maxHeight: '80%',
    backgroundColor: 'white',
    borderRadius: '8px',
  },
  modalContent: {
    overflowY: 'auto',
    padding: '15px',
  },
  modalClose: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
  agreeContainer: {
    marginLeft: '12px',
    marginRight: '12px',
    display: 'flex',
  },
  agreeDetailContainer: {
    width: '100%',
  },
  agreeTitle: {
    color: '#878b96',
    marginTop: '12px',
    marginBottom: '0px',
    ...fontDefault,
    fontSize: '14px',
  },
  agreeContent: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '14px',
  },
  marginContainer: {
    margin: '0 32px 0 16px',
  },
  agreeButton: {
    ...fontDefault,
    fontSize: '14px',
    color: '#118df5',
    marginBottom: '0px',
  },
  smallInfo: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '10px',
    lineHeight: 1.62,
    display: 'block',
    textAlign: 'center',
  },
}

const CustomCheckbox = withStyles({
  checked: {
    color: '#1a63b6',
  },
})(Checkbox)

class HomePage extends Component {
  state = {
    isAgree: true,
  }

  componentDidMount = () => {
    const { isAgreeConsentInsurance } = this.props
    if (isAgreeConsentInsurance !== null) {
      this.setState({
        isAgree: !!isAgreeConsentInsurance,
      })
    }
  }

  goToVMI = () => {
    const { isAgree } = this.state
    const dataLayer = _.get(window, 'dataLayer', undefined)
    if (!!dataLayer) {
      dataLayer.push({
        Insurancetype: 'Voluntary Motor Insurance',
      })
    }
    const {
      history: { push },
      setUserInput,
      systems,
    } = this.props
    const mixpanel = _.get(window, 'mixpanel', undefined)
    if (!!mixpanel) {
      mixpanel.track('Insurance Car Home Selection', {
        'Insurance type': 'Voluntary Motor Insurance',
        'Consent insurance car': String(isAgree),
      })
    }
    let vmi = _.find(systems, function(o) {
      return o.name === 'voluntary'
    })
    if (!_.get(vmi, 'enable', true)) {
      if (!!mixpanel) {
        mixpanel.track('Insurance Car Error', {
          'Error message': 'Voluntary Motor Insurance service is not enable',
          'Error code': 'E10401',
        })
      }
      if (!!dataLayer) {
        dataLayer.push({
          event: 'error-page', // Required
          errorMsg: 'Voluntary Motor Insurance service is not enable',
        })
      }
      push('/error-maintenance')
      return
    }
    push('/select-car-model')
    setUserInput({
      isAgreeConsentInsurance: isAgree,
      currentProduct: 'V',
      carBrand: null,
      carModel: null,
      carYear: null,
    })
    document.getElementById('rootScreen').scrollTo(0, 0)
  }

  goToCMI = () => {
    const { isAgree } = this.state
    const dataLayer = _.get(window, 'dataLayer', undefined)
    if (!!dataLayer) {
      dataLayer.push({
        Insurancetype: 'Compulsory Motor Insurance',
      })
    }
    const {
      history: { push },
      setUserInput,
      systems,
    } = this.props
    const mixpanel = _.get(window, 'mixpanel', undefined)
    if (!!mixpanel) {
      mixpanel.track('Insurance Car Home Selection', {
        'Insurance type': 'Compulsory Motor Insurance',
        'Consent insurance car': String(isAgree),
      })
    }
    let cmi = _.find(systems, function(o) {
      return o.name === 'compulsory'
    })
    if (!_.get(cmi, 'enable', true)) {
      if (!!mixpanel) {
        mixpanel.track('Insurance Car Error', {
          'Error message': 'Compulsory Motor Insurance service is not enable',
          'Error code': 'E10402',
        })
      }
      if (!!dataLayer) {
        dataLayer.push({
          event: 'error-page', // Required
          errorMsg: 'Compulsory Motor Insurance service is not enable',
        })
      }
      push('/error-maintenance')
      return
    }
    push('/select-package')
    setUserInput({
      isAgreeConsentInsurance: isAgree,
      currentProduct: 'C',
      carBrand: null,
      carModel: null,
      carYear: null,
    })
    document.getElementById('rootScreen').scrollTo(0, 0)
  }

  render() {
    const { classes } = this.props
    const { isAgree } = this.state
    return (
      <Wrapper>
        <Body>
          <div className={classes.backgroundImageContainer}>
            <img
              alt="background_image"
              className={classes.backgroundImage}
              src={Lost}
            />
            <span className={classes.smallInfo} style={{ marginTop: '8px' }}>
              ใบอนุญาตจากกรมพัฒนาธุรกิจการค้า เลขที่ 0105563116998
            </span>
            <span className={classes.smallInfo} style={{ marginBottom: '8px' }}>
              ใบอนุญาตนายหน้าประกันวินาศภัย เลขที่ ว00018/2563
            </span>
          </div>
          <div className={classes.container}>
            <Grid container>
              <Grid item xs={12} style={{ padding: '0 12px 0 12px' }}>
      <p style={{fontWeight: 'bold'}}>เลือกผลิตภัณฑ์ และแตะปุ่ม “สนใจ” เพื่อกรอกใบสมัคร และรับคำแนะนำจากเจ้าหน้าที่</p>
              </Grid>
              <Grid item xs={12} style={{ padding: '12px 0' }}>
                <div className={classes.cardContainer}>
                  <div className={classes.card} onClick={this.goToVMI}>
                    <div className={classes.cardTop} style={{backgroundColor: "#0e8df4"}}>
                    <span className={classes.cardTitle}>
                      ประกันรถยนต์ ชั้น 1,2+ และ 3
                    </span>
                    <span className={classes.cardDetail}>
                      ซื้อง่าย อุ่นใจทุกเส้นทาง
                    </span>
                    </div>
                    <div className={classes.cardBottom}>
                    <div className={classes.cardButtonContainer}>
                      <button className={classes.cardButton}>สนใจ</button>
                    </div>
                    </div>
                  </div>
                  <div className={classes.card} onClick={this.goToCMI}>
                    <div className={classes.cardTop} style={{backgroundColor: "#223878"}}>
                    <span className={classes.cardTitle}>
                      พ.ร.บ. ซื้อง่าย ราคาเบาๆ
                    </span>
                    <span className={classes.cardDetail}>
                      คุ้มครองคุณ และคู่กรณีทันที
                    </span>
                  </div>
                    <div className={classes.cardBottom}>
                    <div className={classes.cardButtonContainer}>
                      <button className={classes.cardButton}>สนใจ</button>
                    </div>
                  </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} style={{ padding: '12px 0' }}>
                <span className={classes.moreNewDesc}>
                  สอบถามข้อมูล
                  <ul style={{ margin: '0px' }}>
                    <li>บมจ.กรุงเทพประกันภัย โทร. 02 285 8888</li>
                    <li>แอสเซนต์ แอสชัวรันส์ โบรกเกอร์ โทร. 1240</li>
                  </ul>
                </span>
              </Grid>
              <Grid item xs={12} style={{ padding: '12px 0' }}>
                <span className={classes.moreDesc}>
                  ทรูมันนี่ วอลเล็ท เป็นเพียงช่องทางชำระเงิน
                  และทำหน้าที่เป็นช่องทาง
                  ในการเชื่อมต่อขอรับบริการทางอิเล็กทรอนิกส์กับ
                  <br />
                  แอสเซนด์ แอสชัวรันส์ โบรกเกอร์ เท่านั้น ทรูมันนี่
                  วอลเล็ทไม่มีส่วน
                  เกี่ยวข้องในการพิจารณาหรือรับผิดชอบการรับประกันภัย
                  <br />
                  <br />
                </span>
              </Grid>
            </Grid>
          </div>
          <Modal styles={{ outline: 0 }} open={false}>
            <div className={classes.modalContainer}>
              <IconButton
                className={classes.modalClose}
                onClick={() => {
                  window.location.replace('ascendmoney://closewebview')
                }}
              >
                <Icon style={{ fontSize: '18px', color: '#4A4A4A' }}>
                  close
                </Icon>
              </IconButton>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  marginTop: '16px',
                }}
              >
                <img
                  alt="error_image"
                  src={ErrorKYC}
                  style={{ width: '100px', height: '100px' }}
                />
              </div>
              <p
                style={{
                  ...fontDefault,
                  fontWeight: 'bold',
                  fontSize: '18px',
                  textAlign: 'center',
                  marginLeft: '15px',
                  marginRight: '15px',
                  color: '#0e162c',
                }}
              >
                ยืนยันตัวตน
              </p>
              <p
                style={{
                  ...fontDefault,

                  marginLeft: '15px',
                  marginRight: '15px',
                  fontSize: '16px',
                  color: '#999999',
                }}
              >
                กรุณายืนยันตัวตนก่อนซื้อประกัน เพื่อความปลอดภัยในการใช้งาน
              </p>

              <SubmitButton
                onClick={() => {
                  window.location.replace('ascendmoney://closewebview')
                }}
              >
                ตกลง
              </SubmitButton>
            </div>
          </Modal>
        </Body>
        <Footer>
          <div
            style={{
              backgroundColor: '#e3eaf2',
              padding: '7px',
              textAlign: 'center',
            }}
          >
            <span>
              คุณได้ออกจาก ทรูมันนี่ วอลเล็ทและได้เข้าสู่บริการของ
              <br />
              แอสเซนด์ แอสชัวรันส์ โบรกเกอร์ แล้ว
            </span>
          </div>
        </Footer>
        <Header>
          <TopBar
            close={() => {
              window.location.replace('ascendmoney://closewebview')
            }}
          >
            <Typography align="center" className={classes.textTopBar}>
              ประกันออนไลน์
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    kyc_level: _.get(state, 'auth.kyc_information.kyc_level', 0),
    systems: _.get(state, 'systems'),
    isAgreeConsentInsurance: _.get(
      state,
      'motor.userInput.isAgreeConsentInsurance',
      null
    ),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HomePage))
